import Vue from 'vue';
import VueRouter from 'vue-router';
// import { requireAuth } from './requireAuth';
import HomeLayout from '../components/HomeLayout.vue';
import LoginPage from '../views/company/LoginPage.vue';
import ServicePage from '../views/company/ServicePage.vue';
import PrivacyPage from '../views/company/PrivacyPage.vue';
import SignInPage from '../views/company/SignInPage.vue';
import ProfilePage from '../views/company/ProfilePage.vue';
import PlanPage from '../views/plan/PlanPage.vue';
import OuterPlanPage from '../views/company/OuterPlanPage.vue';
import WorkflowLayout from '../components/WorkflowLayout.vue';
import WorkflowPage from '../views/workflow/WorkflowPage.vue';
import UserEditorPage from '../views/user/editor/UserEditorPage.vue';
import HistoryPage from '../views/workflow/HistoryPage.vue';
import HistoryDetailPage from '../views/workflow/HistoryDetailPage.vue';
import ConnectionPage from '../views/workflow/ConnectionPage.vue';
import TemplatePage from '../views/workflow/TemplatePage.vue';
import LeadListPage from '../views/lead/LeadListPage.vue';
import LeadAddPage from '../views/lead/LeadAddPage.vue';
import ListListPage from '../views/lead/ListListPage.vue';
import ListAddPage from '../views/lead/ListAddPage.vue';
import LeadInListPage from '../views/lead/LeadInListPage.vue';
import DevFirstLayout from '../components/DevFirstLayout.vue';
import DevelopPage from '../views/develop/DevelopPage.vue';
import DevelopCreatePage from '../views/develop/DevelopCreatePage.vue';
import DevSecondLayout from '../components/DevSecondLayout.vue';
import DevActionInputLayout from '../components/DevActionInputLayout.vue';
import DevActionLineItemLayout from '../components/DevActionLineItemLayout.vue';
import DevActSetting from '../views/dev/action/DevActSetting.vue';
import DevActInput from '../views/dev/action/DevActInput.vue';
import DevelopAppPage from '../views/develop/DevelopAppPage.vue';
import DevelopAppdetailPage from '../views/develop/DevelopAppdetailPage.vue';
import DevelopAppTotalPage from '../views/develop/auth/DevelopAppTotalPage.vue';
import DevelopAppAuthPage from '../views/develop/auth/DevelopAppAuthPage.vue';
import DevelopAppAuthCreatePage from '../views/develop/auth/DevelopAppAuthCreatePage.vue';
import DevAuthField from '../views/dev/auth/DevAuthField.vue';
import DevAuthSetting from '../views/develop/auth/DevAuthSetting.vue';
import DevelopAppTriggerPage from '../views/develop/trigger/DevelopAppTriggerPage.vue';
import DevTrigSetting from '../views/dev/trigger/DevTrigSetting.vue';
import DevTrigInput from '../views/dev/trigger/DevTrigInput.vue';
import DevTrigApi from '../views/dev/trigger/DevTrigApi.vue';
import DevActMain from '../views/dev/action/DevActMain.vue';
import DevActApi from '../views/dev/action/DevActApi.vue';
import DevVersion from '../views/dev/version/DevVersion.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'HomeLayout',
    component: HomeLayout,
    redirect: '/login',
    children: [
      {
        path: '/login',
        name: 'LoginPage',
        component: LoginPage,
      },
      {
        path: '/service',
        name: 'ServicePage',
        component: ServicePage,
      },
      {
        path: '/privacy',
        name: 'PrivacyPage',
        component: PrivacyPage,
      },
      {
        path: '/signIn',
        name: 'SignInPage',
        component: SignInPage,
      },
      {
        path: '/profile',
        name: 'ProfilePage',
        component: ProfilePage,
      },
      {
        path: '/plan',
        name: 'PlanPage',
        component: PlanPage,
      },
      {
        path: '/plan-setting',
        name: 'OuterPlanPage',
        component: OuterPlanPage,
      },
      {
        path: '/w',
        name: 'WorkflowLayout',
        component: WorkflowLayout,
        children: [
          {
            path: '/workflows',
            name: 'WorkflowPage',
            component: WorkflowPage,
          },
          {
            path: '/workflows/editor/:editType',
            name: 'UserEditorPage',
            component: UserEditorPage,
          },
          {
            path: '/workflows/history',
            name: 'HistoryPage',
            component: HistoryPage,
          },
          {
            path: '/workflows/history/detail',
            name: 'HistoryDetailPage',
            component: HistoryDetailPage,
          },
          {
            path: '/workflows/connections',
            name: 'ConnectionPage',
            component: ConnectionPage,
          },
          {
            path: '/workflows/template',
            name: 'TemplatePage',
            component: TemplatePage,
          },
        ],
      },
      {
        path: '/lead',
        name: 'LeadListPage',
        component: LeadListPage,
      },
      {
        path: '/lead',
        name: 'LeadAddPage',
        component: LeadAddPage,
      },
      {
        path: '/list',
        name: 'ListListPage',
        component: ListListPage,
      },
      {
        path: '/lead',
        name: 'ListAddPage',
        component: ListAddPage,
      },
      {
        path: '/list/lead',
        name: 'LeadInListPage',
        component: LeadInListPage,
      },
      {
        path: '/df',
        name: 'DevFirstLayout',
        component: DevFirstLayout,
        children: [
          {
            path: '/develop',
            name: 'DevelopPage',
            component: DevelopPage,
          },
          {
            path: '/develop/create',
            name: 'DevelopCreatePage',
            component: DevelopCreatePage,
          },
        ],
      },
      {
        path: '/ds',
        name: 'DevSecondLayout',
        component: DevSecondLayout,
        children: [
          {
            path: '/develop/app/each',
            name: 'DevActionInputLayout',
            component: DevActionInputLayout,
            children: [
              {
                path: '/develop/app/each/:appId/action/input/line-item',
                name: 'DevActionLineItemLayout',
                component: DevActionLineItemLayout,
              },
              {
                path: '/develop/app/action/input',
                name: 'DevActSetting',
                component: DevActSetting,
              },
              {
                path: '/develop/app/action/input',
                name: 'DevActInput',
                component: DevActInput,
              },
            ],
          },
          {
            path: '/develop/app',
            name: 'DevelopAppPage',
            component: DevelopAppPage,
          },
          {
            path: '/develop/app/detail',
            name: 'DevelopAppdetailPage',
            component: DevelopAppdetailPage,
          },
          {
            path: '/develop/app',
            name: 'DevelopAppTotalPage',
            component: DevelopAppTotalPage,
          },
          {
            path: '/develop/app/auth',
            name: 'DevelopAppAuthPage',
            component: DevelopAppAuthPage,
          },
          {
            path: '/develop/app/auth/create',
            name: 'DevelopAppAuthCreatePage',
            component: DevelopAppAuthCreatePage,
          },
          {
            path: '/develop/app/auth/fields',
            name: 'DevAuthField',
            component: DevAuthField,
          },
          {
            path: '/develop/app/auth/edit',
            name: 'DevAuthSetting',
            component: DevAuthSetting,
          },
          {
            path: '/develop/app/trigger',
            name: 'DevelopAppTriggerPage',
            component: DevelopAppTriggerPage,
          },
          {
            path: '/develop/app/trigger/setting',
            name: 'DevTrigSetting',
            component: DevTrigSetting,
          },
          {
            path: '/develop/app/trigger/input',
            name: 'DevTrigInput',
            component: DevTrigInput,
          },
          {
            path: '/develop/app/trigger/api',
            name: 'DevTrigApi',
            component: DevTrigApi,
          },
          {
            path: '/develop/app/action/setting',
            name: 'DevActMain',
            component: DevActMain,
          },
          {
            path: '/develop/app/action/api',
            name: 'DevActApi',
            component: DevActApi,
          },
          {
            path: '/develop/app/version',
            name: 'DevVersion',
            component: DevVersion,
          },
        ],
      },
    ],
  },
];
const router = new VueRouter({
  routes,
});

export default router;
